// Puntos ocultos oficiales, estilo TOTP: el clic calcula
// code = HMAC(secretoDelJugador, `{bloque}:{pointId}`) y lo manda en un solo
// POST con la prueba del gesto. El servidor verifica el código contra la
// hora oficial sin haber emitido nada antes; los puntos los fija el servidor
// y cada punto se cobra una vez por hora. El cliente nunca declara cantidades.
const sessionToken = () => {
  try {
    return localStorage.getItem('nacanaca-session') || '';
  } catch {
    return '';
  }
};

// Sin timeout un fetch colgado deja al mapa esperando para siempre (en el
// cambio de hora se vio el cliente "bugeado": toques sin respuesta y recarga
// colgada). Mismo patrón que rankingApi: AbortController + timeout corto.
const REQUEST_TIMEOUT_MS = 8000;

async function fetchWithTimeout(url, options = {}, timeoutMs = REQUEST_TIMEOUT_MS) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  try {
    return await fetch(url, { ...options, signal: controller.signal });
  } catch (error) {
    if (error?.name === 'AbortError') {
      throw new Error('La red está tardando demasiado. Revisa tu conexión e inténtalo de nuevo.');
    }
    throw error;
  } finally {
    clearTimeout(timeout);
  }
}

async function readPayload(response) {
  const data = await response.json().catch(() => ({ error: 'El servidor devolvió una respuesta inválida.' }));
  if (!response.ok) {
    const error = new Error(data.error || `El servidor respondió ${response.status}.`);
    error.status = response.status;
    error.code = data.code;
    if (Number.isFinite(data.retryAfterSec)) error.retryAfterSec = data.retryAfterSec;
    throw error;
  }
  return data;
}

export async function fetchHiddenPointsConfig() {
  const response = await fetchWithTimeout('/api/config/hidden-points', {
    headers: { Accept: 'application/json' },
  });
  return readPayload(response);
}

export async function fetchMyHiddenPoints() {
  const token = sessionToken();
  if (!token) {
    const error = new Error('Sin sesión de jugador.');
    error.status = 401;
    throw error;
  }
  const response = await fetchWithTimeout('/api/hidden-points/me', {
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
  });
  return readPayload(response);
}

export async function collectHiddenPoint({ pointId, code, proof, turnstileToken }) {
  const session = sessionToken();
  if (!session) {
    const error = new Error('Inicia sesión para juntar puntos ocultos.');
    error.status = 401;
    throw error;
  }
  const response = await fetchWithTimeout('/api/hidden-points/collect', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${session}`,
    },
    body: JSON.stringify({ pointId, code, proof, turnstileToken }),
  }, 10000);
  return readPayload(response);
}
